import { render, staticRenderFns } from "./ComplaintDialog.vue?vue&type=template&id=6fca223a&scoped=true"
import script from "./ComplaintDialog.vue?vue&type=script&lang=js"
export * from "./ComplaintDialog.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDialog.vue?vue&type=style&index=0&id=6fca223a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca223a",
  null
  
)

export default component.exports